import { Box, Typography } from "@mui/material";
import React from "react";
import CustomVideoPlayer from "../../videoPlayer/CustomVideoPlayer";
import BoldText from "../../boldText/BoldText";
import './videoCard.scss'

const VideoCard = ({
    videoUrl,
    isPlaying,
    showVideoDescription,
    onClickPlay,
}:any) => {
  return (
    <Box className="pujaVideoCard" >
      <CustomVideoPlayer
        key={videoUrl}
        src={videoUrl}
        isPlaying={isPlaying}
        onClickPlay={(isPlay:boolean)=>{
            onClickPlay(isPlay)
        }}
        width="100%"
        height="220px"
      />

      <Box className="pujaVideoInfo">
        {showVideoDescription ? (
          <Typography variant="subtitle2" className="showVideoDescription">
            <BoldText text={showVideoDescription} />
          </Typography>
        ) : (
          <Box className="videoDescriptionPlaceholder" />
        )}
      </Box>
    </Box>
  );
};

export default VideoCard;
